import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CircleIcon } from '../../assets/images/circle.svg';
import { ReactComponent as RingIcon } from '../../assets/images/ring.svg';
import { ReactComponent as HexagonIcon } from '../../assets/images/hexagon.svg';
import { ReactComponent as RectangleIcon } from '../../assets/images/rectangle.svg';
import { ReactComponent as StrokeIcon } from '../../assets/images/stroke.svg';
import { LEGEND_ICON_TYPES } from '../../types/legendTypes';

/**
 * LegendIconRenderer - Универсальный компонент для рендеринга иконок легенд
 * Поддерживает разные типы иконок (circle, hexagon, rect, line и т.д.)
 */
export const LegendIconRenderer = ({
    type = LEGEND_ICON_TYPES.CIRCLE,
    color,
    size = '2vw',
    opacity = 0.8,
    strokeWidth = 2,
}) => {
    const commonProps = {
        width: size,
        height: size,
        opacity,
    };

    switch (type) {
        case LEGEND_ICON_TYPES.CIRCLE:
            return (
                <CircleIcon
                    {...commonProps}
                    fill={color}
                />
            );

        case LEGEND_ICON_TYPES.RING:
            return (
                <RingIcon
                    {...commonProps}
                    stroke={color}
                    strokeWidth={strokeWidth}
                />
            );

        case LEGEND_ICON_TYPES.HEXAGON:
            return (
                <HexagonIcon
                    {...commonProps}
                    fill={color}
                />
            );

        case LEGEND_ICON_TYPES.RECT:
            return (
                <RectangleIcon
                    {...commonProps}
                    fill={color}
                />
            );

        case LEGEND_ICON_TYPES.LINE:
            return (
                <StrokeIcon
                    {...commonProps}
                    stroke={color}
                    strokeWidth={strokeWidth}
                />
            );

        case LEGEND_ICON_TYPES.CUSTOM:
        case LEGEND_ICON_TYPES.NONE:
        default:
            return null;
    }
};

LegendIconRenderer.propTypes = {
    type: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    opacity: PropTypes.number,
    strokeWidth: PropTypes.number,
};

LegendIconRenderer.defaultProps = {
    type: LEGEND_ICON_TYPES.CIRCLE,
    opacity: 0.8,
    strokeWidth: 2,
};
